export default __webpack_public_path__ + "static/media/the-swag-shop.e8ae91b2.png";